import { Component, Inject } from '@angular/core';
import { RentalClientsTableSettings } from '@/table-settings/rentals/rental-clients-table-settings';
import { DataSourceTable } from '@components/new-table/data-sources/data-source-table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomButtonInterface } from '@components/new-table/custom-button-interface';
import { Registry } from '@/registry.service';

@Component({
  selector: 'app-dialog-select-company-rent',
  templateUrl: './dialog-select-company-rent.component.html',
})
export class DialogSelectCompanyRentComponent {
  displayedColumns = RentalClientsTableSettings.getColumnsSetting();
  dataSource = new DataSourceTable(this.data.service);
  customButtons: CustomButtonInterface[];

  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.customButtons = [
      {
        btnCustomShowIcon: false,
        btnCustomText: 'Seleziona',
        btnCustomClickEvent: this.btnSelectClientClickFunction,
      },
    ];
  }

  btnSelectClientClickFunction($event: any) {
    if (Registry.getInstance().get('closeSelectCompanyEvent$') !== undefined) {
      Registry.getInstance().get('closeSelectCompanyEvent$').emit($event);
    }
  }
}
